import React, { memo, useCallback, useMemo, useState } from 'react'
import { Badge, Dropdown, Tooltip } from 'antd'
import { useIntl } from 'react-intl'
import News from 'containers/Notification/News'
import { useResponsive } from 'utils/hooks'
import { useUpdateReadNews } from 'utils/queries'
import { useSelector } from 'react-redux'
import { darkModeSelector, userSelector } from 'app-redux/selectors'
import { compareWithJSON } from 'utils/helper'

import styles from './style.module.scss'

const ICON_BASE = 'resources/images/icons/menu-v2'

const Actions = () => {
  const { formatMessage } = useIntl()

  const [visible, setVisible] = useState(false)

  const darkMode = useSelector(darkModeSelector)
  const { is_show_news: isShowNews, id: userId } = useSelector(userSelector)
  const { mutate: updateReadNews } = useUpdateReadNews()

  const { isMobileView } = useResponsive()

  const visibleChangeHandler = useCallback(
    (flag) => {
      setVisible(flag)
      if (isShowNews === 1) {
        updateReadNews(userId)
      }
    },
    [updateReadNews, userId, isShowNews],
  )

  const stylePane = useMemo(() => {
    const style = { height: 400, overflow: 'auto' }

    if (!isMobileView) {
      style.width = 400
    }

    return style
  }, [isMobileView])

  const popupRender = useCallback(() => {
    return (
      <div
        className={`card cui__utils__shadow width-350 overflow-hidden border-0 ${
          darkMode ? 'bg-dark-3 text-light' : 'bg-light'
        }`}
      >
        <div className="card-body" style={stylePane}>
          <News />
        </div>
      </div>
    )
  }, [darkMode, stylePane])

  return (
    <Tooltip
      open={visible ? false : undefined}
      title={formatMessage({ id: 'topBar.latestKledoUpdate' })}
    >
      <div className={styles.trigger}>
        <Dropdown
          popupRender={popupRender}
          trigger={['click']}
          placement="bottomRight"
          open={visible}
          arrow
          onOpenChange={visibleChangeHandler}
        >
          <div className={`${styles.dropdown} ${visible ? styles.open : ''}`}>
            <Badge
              dot={isShowNews === 1}
              size="small"
              offset={[-5, 5]}
              className={styles.notificationBadge}
            >
              <span className={styles.illus}>
                <img src={`${ICON_BASE}/notification.svg`} alt="" />
              </span>
            </Badge>
          </div>
        </Dropdown>
      </div>
    </Tooltip>
  )
}

export default memo(Actions, compareWithJSON)
